import React, { useEffect } from 'react';
import Formulario from './formulario';

export const FormularioSubFunciones = (props: any) => {
	let { handle, selected, onClose } = props;

	useEffect(()=>{},[props])

	return <Formulario onSave={handle} selected={selected} onClose={onClose}/>;
};

export default FormularioSubFunciones;